export default __webpack_public_path__ + "alberta-delete.5e26b122e7d0c3e28693.svg";